module.exports = __webpack_public_path__ + "static/media/kotlin_android.aefd1e38.png";